export default {"src":"/_next/static/media/check-circe-icon.a8752d48.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};